export default "__VITE_ASSET__Bkc_MmAX__"